import React from "react";
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";

// Stable, distinct colours for avatars without a photo (seeded by name or number).
const PALETTE = ["#1565c0", "#2e7d32", "#6a1b9a", "#ad1457", "#ef6c00", "#00838f", "#4527a0", "#c62828", "#283593", "#00695c"];

export const avatarColor = (seed) => {
  const s = String(seed || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
};

export const initialsOf = (name) => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
};

/**
 * Avatar for a contact or phone number: photo if available, otherwise coloured
 * initials, falling back to a person icon when there is no name.
 */
export default function ContactAvatar({ name, number, image, size = 40, className, style }) {
  const hasName = /[a-z]/i.test(name || "");
  const initials = hasName ? initialsOf(name) : "";
  const seed = hasName ? String(name).trim() : number;
  const dim = { width: size, height: size, fontSize: Math.round(size * 0.4), ...style };

  if (image) {
    return <Avatar src={image} alt={name || String(number || "")} className={className} style={dim} />;
  }
  return (
    <Avatar className={className} style={{ ...dim, backgroundColor: avatarColor(seed), color: "#fff" }}>
      {initials || <PersonIcon style={{ fontSize: Math.round(size * 0.6) }} />}
    </Avatar>
  );
}
